let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lqNA7")).then(() => parcelRequire('1lPo9'));